import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";
import axios from "axios";
import Select from 'react-select';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";

class TableauReportAccessPermission extends Component{
    constructor(props) {
        super(props);
        this.state = {
            reportPermissionsArray:[],
            all_tableau_projects:[],
            all_tableau_workbook:[],
            all_tableau_worksheet:[],
            user_list:[],
            userValue: {value: '', label: 'Select User'},
            selected_user_id:"",
            selected_project:[],
            selected_workbook:[],
            selected_worksheet:[],
            _notificationSystem: null,
            check_all: false,
            all_project_kpis:[],
            all_workbook_kpis:[],
            all_worksheet_kpis:[],
            departmentLists:[],
            department_id:''

        }
    }
     componentWillMount() {
       this.props.currentMenu("unipaynext");
     }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        this.get_tableau_project();
        //this.get_all_internal_users();
        this.get_department();
    }

    get_department(){
        axios.post(config.get('API_URL') + '/users/userdepartment/', {

            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
               this.setState({
                    departmentLists: response.data,

               })

        });
    }
    get_all_internal_users(){
        axios.post(config.get('API_URL')+'/tableau/get-all-internal-users/',
         {

         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            console.log("dddd",response)
            if(Array.isArray(response.data) && response.data.length) {
                var mList = [{value: '', label: 'Select User'}]
                response.data.map((user, index) => {
                    mList.push({value: user.user_id, label: user.email})
                });
                this.setState({
                    user_list:mList,
                    is_merchant_loading: false
                })
            }


        }).catch( err => {
            console.log(err);
        });
    }
    get_tableau_project(){
        axios.post(config.get('API_URL')+'/tableau/get-all-tableau-report-lists/',
         {

         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {

            let prj = [];
            response.data.allproject.map((prjc,index) => {
                prj.push(prjc.project_id)
            });
            let wrb = [];
            response.data.allworkbook.map((wrbk,index) => {
                wrb.push(wrbk.workbook_id)
            });
            let wrs = [];
            response.data.allworksheet.map((wrst,index) => {
                wrs.push(wrst.view_id)
            });
            this.setState({
                all_tableau_projects:response.data.allproject,
                all_tableau_workbook:response.data.allworkbook,
                all_tableau_worksheet:response.data.allworksheet,
                all_project_kpis:prj,
                all_workbook_kpis:wrb,
                all_worksheet_kpis:wrs
            });
//             let projects=[]; let workbooks = []; let worksheets =[];
//             var j = 0;
//             var ss = false;
//             response.data.allproject.map((val,index) => {
//                 projects.push({
//                 project_id:val.project_id,
//                 project_name:val.project_name,
//                 workbooks:[]
//                 })
//                 var i = 0;
//                 var flag = false;
//                 response.data.allworkbook.map((val1,index1) => {
//
//                     if(val.project_id==val1.project_id ) { ss = true;
//                         projects[j].workbooks.push({
//                         workbook_id:val1.workbook_id,
//                         workbook_name:val1.workbook_name,
//                         worksheets:[]
//                         })
//                     }
//
//                     response.data.allworksheet.map((val2,index2) => {
//                         if(val2.workbook_id===val1.workbook_id && val.project_id==val1.project_id) {
//
//                            flag = true;
//                            console.log(projects[index].workbooks[i]);
//                     try {
//                         projects[index].workbooks[i].worksheets.push({
//                         view_id:val2.view_id,
//                         view_name:val2.view_name
//
//                        })
//                        } catch (e) {
//                                 console.log(e);
//                             }
//                         }
//                     })
//                      if(flag===true) {
//                      i++;
//                      }
//                 })
//
//                 if(ss===true) { j++; }
//             })
//
//         console.log(projects);
        }).catch( err => {
            console.log(err);
        });
    }

    changeUser(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            selected_user_id:value,
            userValue:optionSelected,
            selected_worksheet:[],
            selected_workbook:[],
            selected_project:[]
        });
        this.get_access_data(value);
    }
    get_access_data(val){
         axios.post(config.get('API_URL')+'/tableau/get-user-access-data/',
         {
            user_department: val,
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            //console.log("bbbbb",response)
            if(response.data===null || response.data==='' || response.data==='null') {
                this.setState({
                    selected_worksheet:[],
                    selected_workbook:[],
                    selected_project:[]
                });
            } else {
                this.setState({
                    selected_worksheet:response.data.tableau_worksheet.split(',').map(String),
                    selected_workbook:response.data.tableau_workbook.split(',').map(String),
                    selected_project:response.data.tableau_project.split(',').map(String)
                });
                if(response.data.tableau_worksheet==='') {
                    this.setState({
                        selected_worksheet:[]
                    });
                }
                if(response.data.tableau_workbook==='') {
                    this.setState({
                        selected_workbook:[]
                    });
                }
                if(response.data.tableau_project==='') {
                    this.setState({
                        selected_project:[]
                    });
                }
            }
        }).catch( err => {
            console.log(err);
        });
    }
    changeProject(kpi,checked_item, e){
        let item_list = this.state.selected_project
        let checked_list = kpi;
        //console.log(checked_list);
        if(checked_item===false) {
            this.setState({
                selected_project: [...this.state.selected_project,  kpi],

            });

        } else{
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                if(item_list.length<1) {
                    item_list='';
                }
                this.setState({
                    selected_project: item_list,

                })
            }
        }


        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }

    changeWorkbook(kpi1,checked_item1, e){
        let item_list1 = this.state.selected_workbook
        let checked_list1 = kpi1;
        //console.log(checked_list);
        if(checked_item1===false) {
            this.setState({
                selected_workbook: [...this.state.selected_workbook,  kpi1],

            });

        } else{
            let index1 = item_list1.indexOf(checked_list1);
            if (index1 > -1) {
                item_list1.splice(index1, 1);
                if(item_list1.length<1) {
                    item_list1='';
                }
                this.setState({
                    selected_workbook: item_list1,

                })
            }
        }


        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }
    changeWorksheet(kpi2,checked_item2, e){
        let item_list2 = this.state.selected_worksheet
        let checked_list2 = kpi2;
        //console.log(checked_list);
        if(checked_item2===false) {
            this.setState({
                selected_worksheet: [...this.state.selected_worksheet,  kpi2],

            });

        } else{
            let index2 = item_list2.indexOf(checked_list2);
            if (index2 > -1) {
                item_list2.splice(index2, 1);
                if(item_list2.length<1) {
                    item_list2='';
                }
                this.setState({
                    selected_worksheet: item_list2,

                })
            }
        }


        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }

    submitPermission(e){
        if(this.state.department_id==='') {
            this.props.handleClick("tr", 3, "Please Select department");
            return false;
        } else if(this.state.selected_project.length<1) {
            this.props.handleClick("tr", 3, "Please Select Projects");
        }  else if(this.state.selected_workbook.length<1) {
            this.props.handleClick("tr", 3, "Please Select Workbook");
        }  else if(this.state.selected_worksheet.length<1) {
            this.props.handleClick("tr", 3, "Please Select Worksheet");
        }
        axios.post(config.get('API_URL')+'/tableau/save-tableau-report-permission/',
         {
            user_department: this.state.department_id,
            tableau_project: this.state.selected_project,
            tableau_workbook: this.state.selected_workbook,
            tableau_worksheet: this.state.selected_worksheet
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            this.props.handleClick("tr", 1, response.data.message);
        }).catch( err => {
            console.log(err);
        });
    }
    selectAll(e){
        if(e.target.checked===true){
             this.setState({
                check_all: e.target.checked,
                selected_project:this.state.all_project_kpis,
                selected_workbook:this.state.all_workbook_kpis,
                selected_worksheet:this.state.all_worksheet_kpis,
            })
        } else {
             this.setState({
                check_all: e.target.checked,
                selected_project:[],
                selected_workbook:[],
                selected_worksheet:[],
            })
        }

    }
    changeDepartment(e){
        this.setState({
            department_id:e.target.value,
            selected_worksheet:[],
            selected_workbook:[],
            selected_project:[]
        })
        this.get_access_data(e.target.value);

    }
    render() {
//     console.log("A",this.state.all_project_kpis);
//     console.log("S",this.state.selected_project);
    let departments = this.state.departmentLists.map((department, index) => {
            return (
                <option value={department.department_id} key={index + 1}>{department.department_name}</option>
            )
        });
    const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "32px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "35px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        const allList = this.state.all_tableau_projects.map((val,index) => {
            var checked_item = false;
            if(this.state.selected_project.includes(val.project_id) === true){
                checked_item = true;
            }
            return (
            <React.Fragment key={index}>
                <div className="tab_project"><input type='checkbox' checked={checked_item} onClick={this.changeProject.bind(this, val.project_id,checked_item)}/> {val.project_name}</div>
                {this.state.all_tableau_workbook.map((val1,index1) => {
                    var checked_item1 = false;
                    if(this.state.selected_workbook.includes(val1.workbook_id) === true){
                        checked_item1 = true;
                    }
                    return (
                        <React.Fragment key={index1}>
                        {val.project_id==val1.project_id?
                            <div className="tab_workbook"><input type='checkbox' checked={checked_item1} onClick={this.changeWorkbook.bind(this, val1.workbook_id,checked_item1)}/> {val1.workbook_name}</div>:null}
                            {this.state.all_tableau_worksheet.map((val2,index2) => {
                                var checked_item2 = false;
                                if(this.state.selected_worksheet.includes(val2.view_id) === true){
                                    checked_item2 = true;
                                }
                                return (
                                <React.Fragment key={index2}>
                                {val2.workbook_id===val1.workbook_id && val.project_id==val1.project_id?
                                <div className="tab_worksheet">
                                      <input type='checkbox' checked={checked_item2} onClick={this.changeWorksheet.bind(this, val2.view_id,checked_item2)}/>&nbsp;{val2.view_name}</div>:null}
                                    </React.Fragment>
                                );
                            })}
                        </React.Fragment>
                    );
                })}
            </React.Fragment>
            );
          })

        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                                <NotificationSystem ref="notificationSystem" style={style} />
                                               <div className="header">
                                                    <h4 className="title">Tableau Report Access Permission</h4>
                                                  <p className="category"></p>
                                               </div>
                                                <div className="content">
                                                    <div className="row">
                                                        <div className="col-md-2"></div>
                                                        <div className="col-md-8">
                                                        <label>Select Department </label>
                                                        <select id="tableau_user" name="department" className="form-control"
                                                            value={this.state.department_id}
                                                            onChange={this.changeDepartment.bind(this)}
                                                            >
                                                            <option value=" ">Select Department</option>
                                                        {departments}
                                                        </select>
{/*                                                         <Select name="user" */}
{/*                                                                 value={this.state.userValue} */}
{/*                                                                 styles={customStyles} className="report-listbox" */}
{/*                                                                 isClearable={false} */}
{/*                                                                 onChange={this.changeUser.bind(this)} */}
{/*                                                                 options={this.state.user_list} */}
{/*                                                                 defaultValue={{ label: "Select User", value: "" }} */}
{/*                                                         /> */}
                                                        <div className="rep-con">
                                                          <div>
                                                            <input type='checkbox' checked={this.state.check_all} onClick={this.selectAll.bind(this)}/>&nbsp;Select All
                                                          </div>
                                                          <hr/>
                                                          {allList}
                                                          </div>
                                                          <div className="row">
                                                          <br/>
                                                            <div className="col-md-2 pull-right"><button type="button" className="btn btn-primary" onClick={this.submitPermission.bind(this)}>Submit</button></div>
                                                          </div><br/>
                                                          </div>
                                                          <div className="col-md-2"></div>
                                                          <div className="clearfix"></div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="header">*/}
                                {/*    <h4 className="title">Transaction</h4>*/}
                                {/*    <p className="category"></p>*/}
                                {/*</div>*/}

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(TableauReportAccessPermission);